{ featureFlagClient } = require '@trello/feature-flag-client'

touchPointsflagId = 'growth.trello-confluence-crossflow-touchpoint-experiment-m0'
defaultFlagValue = 'not-enrolled'

isEnrolledInConfluenceLearningExperiment = ->
  cohort = featureFlagClient.get learningExperimentFlagId, defaultFlagValue
  if cohort != defaultFlagValue
    # calling getTrackedVariation so that an exposure event will be triggered
    featureFlagClient.getTrackedVariation(
      learningExperimentFlagId,
      defaultFlagValue
    )
  return cohort == 'variation'

isEnrolledInConfluenceCrossflow = (touchPoint, fireExposed = true) ->
  cohort = featureFlagClient.get touchPointsflagId, defaultFlagValue
  if cohort != defaultFlagValue and fireExposed
    # calling getTrackedVariation so that an exposure event will be triggered
    featureFlagClient.getTrackedVariation(
      touchPointsflagId,
      defaultFlagValue,
      { touchPoint }
    )
  return cohort == 'variation'

module.exports = {
  isAtlassianSwitcherActive: ->
    isEnrolledInConfluenceCrossflow('switcher', false)

  fireAtlassianSwitcherActiveEvent: ->
    isEnrolledInConfluenceCrossflow('switcher', true)

  isPowerUpStoreActive: ->
    isEnrolledInConfluenceCrossflow('powerUpsStore')
}